// Builds the GraphProxy /users query used to look a user up by the email they
// signed in with. Mirrors the backend GraphController.ResolveUserKeyAsync
// fallback search: that email isn't always the user's `mail` field or UPN —
// it may be an SMTP alias, a SIP (Teams) address, or in otherMails — so a naive
// `mail eq '...'` filter returns nothing and callers lose officeLocation etc.
// Matching every address the account might own avoids that miss.
//
// Filtering proxyAddresses/otherMails is an OData "advanced query": it requires
// $count=true together with the ConsistencyLevel: eventual header. The GraphProxy
// backend adds that header on /users passthroughs; we supply $count=true here.
// Omitting either silently returns an empty result.
export const graphUserByEmailUrl = (email) => {
  const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
  const escaped = String(email).replaceAll("'", "''"); // OData single-quote escape

  const filter =
    `proxyAddresses/any(p:p eq 'smtp:${escaped}') ` +
    `or proxyAddresses/any(p:p eq 'SIP:${escaped}') ` +
    `or mail eq '${escaped}' ` +
    `or otherMails/any(m:m eq '${escaped}') ` +
    `or userPrincipalName eq '${escaped}'`;

  return (
    `${apiEndpoint}/api/GraphProxy/v1.0/users` +
    `?$count=true&$filter=${encodeURIComponent(filter)}`
  );
};
